import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";

const SYNC_URL = () => `${CONFIG.COURSEURL}/api/v2/video-watch/sessions/sync`;

// Sends buffered watch-time sessions. Only IDs and numbers are sent - the backend takes the
// student from the JWT. Errors are NOT caught: the sync manager needs the real HTTP status
// to decide between "retry later" and "drop". Plain axios (not v2Axios) on purpose: a failed
// background sync must never trigger the central 401 -> logout interceptor.
export const syncWatchTimeService = async (sessions, { keepalive = false } = {}) => {
	const authToken = Cookies.get("authToken");
	const body = { sessions };
	if (keepalive && typeof fetch === "function") {
		// page is going away: fetch+keepalive is the only request that may outlive it
		// (sendBeacon cannot set the Authorization header this API requires)
		const response = await fetch(SYNC_URL(), {
			method: "POST",
			keepalive: true,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${authToken}`,
			},
			body: JSON.stringify(body),
		});
		if (!response.ok) {
			const error = new Error(`watch sync failed: ${response.status}`);
			error.response = { status: response.status };
			throw error;
		}
		return response.json();
	}
	const response = await axios.post(SYNC_URL(), body, {
		headers: { Authorization: `Bearer ${authToken}` },
	});
	return response.data;
};
